import {Notification, Transition} from '@mantine/core';
import Image from 'next/image';
import type React from 'react';
import {useEffect, useState} from 'react';
import {MdClose} from 'react-icons/md';
import {buildCompanyFollowGtmContent} from '../../../../../shared/services/buildCompanyFollowGtmContent';
import {EntryButtonPC} from '../../EntryButton/pc';
import {FollowCompanyButton} from '../../FollowButton';

type Props = {
  companyName: string;
  logoURL?: string;
  entryURL?: string;
  registrationURL?: string;
  companyId: number;
  followerCount: number;
  isFollowed: boolean;
  onFollow: () => void | Promise<void>;
  opened: boolean;
  close: () => void;
};

export const PcFloatEntryButton: React.FC<Props> = ({
  companyName,
  logoURL,
  entryURL,
  registrationURL,
  companyId,
  followerCount,
  isFollowed,
  onFollow,
  opened,
  close,
}) => {
  const [showImage, setShowImage] = useState(true);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        // スクロール位置を調整
        setMounted(true);
      } else {
        setMounted(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Transition
      mounted={mounted && opened}
      transition="fade"
      duration={600}
      timingFunction="ease"
    >
      {(styles) => (
        <Notification
          id="pc_float_entry_button"
          className={
            'fixed transition-transform duration-300 p-16 rounded-l-16 top-[180px] right-0 before:bg-transparent hidden pc:block'
          }
          withCloseButton={false}
          style={styles}
        >
          <div className="cursor-pointer w-full flex justify-end">
            <MdClose onClick={close} />
          </div>
          <div className="flex flex-col items-center">
            <div>
              {showImage && (
                <Image
                  className="rounded-16 overflow-hidden line-clamp-1"
                  src={logoURL ?? ''}
                  width={60}
                  height={60}
                  alt={`${companyName}のメイン写真`}
                  onError={() => {
                    setShowImage(false);
                  }}
                />
              )}
            </div>
            <div className="font-bold text-md w-[200px] line-clamp-2">
              {companyName}
            </div>
            <div className="mt-16 flex justify-center">
              <FollowCompanyButton
                companyId={companyId}
                initial={{
                  followerCount,
                  isFollowed,
                }}
                hasPlus={false}
                className="rounded-[8px] w-[180px]"
                controlled={{
                  isFollowed,
                  followCount: followerCount,
                  onFollow,
                }}
                dataGtmContent={buildCompanyFollowGtmContent({
                  companyId,
                  companyName,
                  location: 'company-detail-float',
                })}
              />
            </div>
            <EntryButtonPC
              entryURL={entryURL}
              registrationURL={registrationURL}
              size="base"
            />
          </div>
        </Notification>
      )}
    </Transition>
  );
};
